import axios from 'axios';
import React from 'react'
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom'
import cookies from "js-cookie"
const DoiRedirect = () => {
    const [loading, setLoading]  = useState(true);
    const [q] = useSearchParams();
    const nav = useNavigate();
    let msisdn = q.get("msisdn");
    let subscription_id = q.get("subscription_id");
    let ext_ref = q.get("ext_ref");
    // const subdomain='diskichat'
    
    axios.get(
        `https://callback.bubblebobble.co.za/api/subscribe/check-sub?msisdn=${msisdn}&subscription_id=${subscription_id}`
    ).then(resp => {
        const data = resp.data;
        console.log("check-data =>", data);
        setLoading(false)
        if(data.result == 1) {
            cookies.set("bubbo-ani", msisdn, {
                expires: 7
            });
            nav(`/redirect?msisdn=${msisdn}`);
        }
        else{
            nav('/')
        }
    }).catch(e => {
        setLoading(false);
        nav("/")
    })
    if(loading) return <h1>redirecting....</h1>
}

export default DoiRedirect
